import type { AxiosError, AxiosResponse } from 'axios';

export interface ApiErrorData {
  message: string;
  code?: string;
}

export class AppError extends Error {
  public readonly originalError: AxiosError;
  public readonly data: ApiErrorData | undefined;
  public readonly status: number | undefined;

  constructor(axiosError: AxiosError) {
    super(axiosError.message || 'An unexpected error occurred.');
    this.name = 'AppError';

    const errorMessage =
      (axiosError.response as AxiosResponse<{ message?: string }> | undefined)?.data?.message || axiosError.message;
    this.originalError = axiosError;
    this.data = {
      message: errorMessage,
      code: axiosError.code,
    };
    this.status = axiosError.response?.status;
  }
}
